module.exports = __webpack_public_path__ + "img/Upload.65731385.svg";